import React, {useEffect, useState} from "react";
import {NavLink, useLocation} from "react-router-dom";
import {
    Box, Button,
    Flex,
    Heading, Spinner,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import DefaultAuth from "layouts/auth/Default";
// Assets
import illustration from "assets/img/auth/landingpage-background.jpg";
import {getData} from "../../../services/api";
import Footer from "../../../components/footer/FooterAuth";

function Verify() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    const textColor = useColorModeValue("navy.700", "white");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                await getData(`/api/verify-email/${token}`);
                setSuccess(true);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        };

        // Call the async function
        fetchData();
    }, []);

    return (
        <Box>
            <DefaultAuth illustrationBackground={illustration} image={illustration}>
                <Flex
                    maxW={{base: "100%", md: "500px"}}
                    w={{base: "100%", md: "40vw"}}
                    mx={{base: "auto", lg: "0px"}}
                    me='auto'
                    h='100%'
                    alignItems='start'
                    justifyContent='center'
                    mb={{base: "30px", md: "60px"}}
                    px={{base: "25px", md: "0px"}}
                    mt={{base: "40px", md: "14vh"}}
                    flexDirection='column'>
                    <Box me='auto'>
                        <Heading color={textColor} fontSize='36px' mb='10px'>
                            Verifizierung
                        </Heading>
                    </Box>
                    {loading ? (
                        <Box>
                            <Text
                                fontWeight='400'
                                fontSize='md'
                                w={{base: "100%", md: "420px"}}
                                mb={5}
                            >
                                Registrierung wird verifiziert
                            </Text>
                            <Spinner size="lg"/>
                        </Box>
                    ) : success ? (
                        <Box>
                            <Text
                                fontWeight='400'
                                fontSize='md'
                                w={{base: "100%", md: "420px"}}
                            >
                                Deine Registrierung wurde erfolgreich verifiziert. Du kannst dich nun mit deinen
                                Login-Daten anmelden.
                            </Text>
                            <NavLink to={'/auth/login'}>
                                <Button
                                    fontSize='md'
                                    variant='brand'
                                    fontWeight='500'
                                    w='100%'
                                    h='50'
                                    mt='24px'
                                    mb='24px'
                                >
                                    Zum Login
                                </Button>
                            </NavLink>
                        </Box>
                    ) : error ? (
                        <Box>
                            <Text
                                fontWeight='400'
                                fontSize='md'
                                w={{base: "100%", md: "420px"}}
                            >
                                Deine Registrierung konnte nicht verifiziert werden oder wurde bereits verifiziert. Bitte versuche dich mit deinen Zugangsdaten anzumelden oder wende dich an unseren Support.
                            </Text>
                            <NavLink to={'/auth/login'}>
                                <Button
                                    fontSize='md'
                                    variant='brand'
                                    fontWeight='500'
                                    w='100%'
                                    h='50'
                                    mt='24px'
                                    mb='24px'
                                >
                                    Zum Login
                                </Button>
                            </NavLink>
                        </Box>
                    ) : ''}
                </Flex>
            </DefaultAuth>
            <Footer/>
        </Box>
    )
        ;
}

export default Verify;
